import * as React from 'react';
import { Datagrid, ListProps, NumberField, TextField } from 'react-admin';
import './OrganizationNotificationDatagrid.scss';
import { TranslateField } from "../components/TranslateField";

export const OrganizationNotificationDatagrid = (props: ListProps): React.ReactElement => {
	return (
		<Datagrid rowClick="edit" className="organization-notifications-table" optimized
		          hasBulkActions={true}
		          rowStyle={(row: any) => ({ borderRightColor: row._readAt ? '#49d18c' : '#bbbbbb' })}>
			<NumberField source="dayInMonth" label="DAY_IN_MONTH"/>
			<TextField source="title" label="TITLE"/>
			<TextField source="body" label="BODY"/>
			<TranslateField source="language" label="LANGUAGE"/>
		</Datagrid>
	);
};
